import ViewProductCategoryContainer from "./ViewProductCategoryContainer";

export default ViewProductCategoryContainer;
